import "./style.css";

export default function Loader() {
  return (
    <div className="loading-container">
      <span className="loading-bar"></span>
      <span className="loading-bar"></span>
      <span className="loading-bar"></span>
      <span className="loading-bar"></span>
    </div>
  );
}
